import React__default from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { useApolloClient } from '@grandvisionhq/graphql';
import { usePaymentsUIContext } from '@grandvisionhq/payments';
import { dispatchCartChangeEvent } from '../../hooks/carts/use-cart-change-listener.js';
import { updateUrlWithReload } from '../../utils/update-url.js';
import { getUpdatedUrlWithQueryParams, appendQueryParamToUrl } from '../../utils/get-updated-url-with-query-params.js';
import { recoverCheckout } from '../../pages/api/recover-checkout.js';

const useHandleQrFormUpdates = ({ qrPaymentConfig , selfUrl , paymentMethodType , paymentMethodLogos , orderDataToken , orderId , paymentFlow ,  })=>{
    const { cart , fetchByCartId  } = Context.useCart();
    const { paymentQRCodeState  } = usePaymentsUIContext();
    const apolloClient = useApolloClient();
    const { push  } = useLocation();
    const { href: orderConfirmHref  } = useLink({
        route: 'order.confirm',
        params: {
            orderData: ''
        }
    }) || {};
    /**
   *  Reload payment page url with new cartId
   *
   */ const updatedUrl = React__default.useCallback((cartId)=>{
        updateUrlWithReload(getUpdatedUrlWithQueryParams({
            cartId,
            type: paymentMethodType
        }));
    }, [
        paymentMethodType
    ]);
    const replicateCart = React__default.useCallback((oldCartId)=>{
        return recoverCheckout(apolloClient, oldCartId);
    }, [
        apolloClient
    ]);
    const refetch = React__default.useCallback((cartId, cartHash)=>{
        fetchByCartId(cartId, cartHash);
        dispatchCartChangeEvent(cartId);
        updatedUrl(cartId);
    }, [
        fetchByCartId,
        updatedUrl
    ]);
    /*
   *  Listen for QR code payment status
   *  if paymentState is 'Paid' then redirect to order confirm page
   */ React__default.useEffect(()=>{
        if (paymentQRCodeState === 'Paid' && orderConfirmHref && orderDataToken) {
            push(appendQueryParamToUrl(orderConfirmHref, {
                cartId: cart === null || cart === void 0 ? void 0 : cart.id,
                orderData: orderDataToken
            }));
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        paymentQRCodeState,
        orderConfirmHref,
        push,
        orderDataToken
    ]);
    /**
   * @description
   * QrCodeFormData for the new paymentMethodsUI
   */ const qrCodeFormData = React__default.useMemo(()=>{
        var ref;
        return {
            paymentMethodType,
            selfUrl,
            logoUrl: paymentMethodLogos && ((ref = paymentMethodLogos[paymentMethodType]) === null || ref === void 0 ? void 0 : ref.url),
            orderId,
            qrPaymentConfig,
            orderToken: orderDataToken,
            refetch,
            paymentFlow,
            getNewCart: replicateCart
        };
    }, [
        paymentMethodType,
        selfUrl,
        paymentMethodLogos,
        orderId,
        qrPaymentConfig,
        orderDataToken,
        refetch,
        paymentFlow,
        replicateCart, 
    ]);
    return [
        qrCodeFormData
    ];
};

export { useHandleQrFormUpdates };
//# sourceMappingURL=use-handle-qr-form-updates.js.map
